module.exports = __webpack_public_path__ + "static/media/my.c906cd0f.webp";